export class GoalTargets {
  constructor(
    public revenueTarget: number,
    public customerTarget: number,
    public receiptTarget: number
  ) {}
}
